<script setup lang="ts">
import type { AddToCartButtonProps } from './PdpEcommerceBlockProductAddToCartButton.props'
const props = defineProps<AddToCartButtonProps>()
const emit = defineEmits<{
  'update:selectedSizeIndex': [selectedSizeIndex: number | null]
  'update:selectedCountry': [selectedCountry: string]
  sendAddToCart: []
}>()
/**
 * `square` pulls in `.cta-large-cart`, which stacks the icon above the label.
 * The full-width button keeps them on one row.
 */
const widthClass = computed(() =>
  props.fullWidth ? 'w-full !flex-row' : 'w-auto'
)

const handleClick = async () => {
  if (props.isOneSize) {
    await emit('update:selectedSizeIndex', 0)
    await emit('update:selectedCountry', props.selectedCountry ?? 'IT')
  }
  emit('sendAddToCart')
}
</script>

<template>
  <MoleculesAddToBag
    :class="widthClass"
    :full-width="fullWidth"
    :square="true"
    :loading="isLoading"
    :disabled="
      disabled ||
      outOfStock ||
      selectedExtOutOfStock ||
      selectedDefaultOrOneSizeOutOfStockCl
    "
    data-testid="desktop-add-to-cart"
    data-tracking="BTN_ADD_TO_CART"
    @click-handler="handleClick"
  />
</template>
